import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
export function ServicesPage() {
  return <>
      <PageBanner title="Our Services" subtitle="Comprehensive fingerprinting solutions for every need, from employment to licensing." data-id="element-516" />
      <Services data-id="element-517" />
      <HowItWorks data-id="element-518" />
    </>;
}